/*
* Story Theme
*
* Use this file to add custom Javascript to Story.  Keeping your custom
* Javascript in this fill will make it easier to update Story. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.





  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();



// ITG-WORK-AGS-11/05/22

$(document).ready(function(){

var  myTimeout = '';
  
  function myInterval(){
    
    var	myId = $('.selected_media .is-selected').attr('id');
    $('.ctm_media_thumb').each(function(){
      var	cmtId = $(this).attr('id');
      if(myId == cmtId){
        $('.ctm_media_thumb').removeClass('is-selected');
        $(this).addClass('is-selected');
      }
      
    });

  }
  
        myTimeout = setInterval(myInterval, 100);
  
  $('.ctm_media_thumb img').click(function(){


    var ctm_img = $(this).data('imgid');
	var ctm_media = $(this).data('media-id');
    
    if ($(document).find('#-select-color').length == 0 && $(document).find('#-select-colour').length == 0){
      $(document).find('.custom_media_wrapper').hide();
      $(document).find('.selected_media.flickity-enabled').show();
    }


    
    var count = 0;
    
    $('#-select-color li,#-select-colour li').each(function(){
      
      var var_id = $(this).data('media_id');
      if(ctm_img == var_id){
        $(this).find('span').click();
        count = 1;
      } else{
        
        $('.ctm_media_thumb').removeClass('is-selected');
        $(this).addClass('is-selected');
        clearTimeout(myTimeout);
        
      }
    }).promise().done(function(){
      if (count == 0) {
        $('.selected_media .media__thumb').each(function(){
          var this_media = $(this).data('media-select');
          if(this_media == ctm_media){
          	$(this).trigger('click');
//            console.log('yes 2');
          }
        });
      }
  });
    



  });
  
  
  function itgImageLoop() {
    var productSlideShow = $(document).find('[data-product-slideshow]');
    if(productSlideShow.hasClass('flickity-enabled')){}else{
      if( productSlideShow.hasClass('itg-select-sliding') ){}else{
      	productSlideShow.find('.product__media:not(".active_slide")').removeClass('itg-active');
      	productSlideShow.find('.product__media:not(".active_slide")').removeClass('itg-checked');
      	productSlideShow.find('.product__media.active_slide').addClass('itg-active');
        if( productSlideShow.find('.itg-active').hasClass('itg-checked') ){}else{
          var imgId = productSlideShow.find('.itg-active').data('image-id');
          $('#-select-color li,#-select-colour li').removeClass('itg-click');
          $('#-select-color li,#-select-colour li').each(function(){
            var var_id = $(this).data('media_id');
            if(imgId == var_id){
              productSlideShow.addClass('itg-sliding');
              $(this).find('span').click();
            }
          });      	
          productSlideShow.find('.product__media.active_slide').addClass('itg-checked');      
        }      
      }
    }
  }

  var interval = self.setInterval(function(){itgImageLoop()},300);

});